/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:block;overflow:hidden;width:100vw;height:100vh}iframe[_ngcontent-%COMP%]{border:none;width:100%;height:calc(100% - 70px)}iframe.full-height[_ngcontent-%COMP%]{height:100%}.ads-frame-top-host[_ngcontent-%COMP%]{margin-top:35px}"];
export { styles as styles };
